import { aponoColors } from '@utils';

export default function useProgressColor() {
  const getColorFromValue = (value: number): string => {
    if (value < 25) return aponoColors.error[500];
    if (value >= 25 && value < 49) return aponoColors.tertiary[500];
    if (value >= 50 && value < 74) return aponoColors.warning[500];
    return aponoColors.success[500];
  };

  return getColorFromValue;
}
